<template>
  <Background v-if="kolamRenang && responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/KOLAM RENANG.png"
        alt="KOLAM RENANG"
        class="pbt-image"
      >
      <div class="line-under-image" />
    </div>

    <div class="content-wrapper">
      <h2>BILANGAN PREMIS KOLAM RENANG</h2>
      <div class="kolam-image-container">
        <div class="video-container">
          <video
            autoplay
            muted
            loop
          >
            <source
              src="@/assets/kolam/kolam-vid.mp4"
              type="video/mp4"
            >
            Your browser does not support the video tag.
          </video>
          <div class="overlay-number">
            {{ kolamRenang.bilangan_premis_kolam_renang }}
          </div>
        </div>
      </div>

      <div class="kolam">
        <div class="kolam-container">
          <img
            src="@/assets/spah/box.png"
            alt="First Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>KOLAM RENANG PBT</h3>
              <p class="num">
                {{ kolamRenang.bilangan_premis_kolam_renang_awam }}
              </p>
            </div>
          </div>
        </div>

        <div class="kolam-container">
          <img
            src="@/assets/spah/box.png"
            alt="Second Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>KOLAM RENANG PERSENDIRIAN</h3>
              <p class="num">
                {{ kolamRenang.bilangan_premis_kolam_renang_swasta }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <Update />
    </div>
  </Background>
  <Menu />
</template>

<script setup>
import Background from '@/components/background/background.vue'
import Menu from '@/components/menu-items/utama-menu.vue'
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'

definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const { loading, error, httpDelete, httpPostPut, httpGet, httpPost,
  numberWithCommas,
  formatToMillion } = useHttpService()

const kolamRenang = ref({
  kolamRenang: {
    // eslint-disable-next-line camelcase
    bilangan_premis_kolam_renang: 0,
  },
})

const responseData = ref(null)

async function loadDataFromApi(){
  try {
    const response = await httpGet('kejuruteraan-kesihatan-umum/kolam-renang')

    responseData.value = response
    kolamRenang.value = response.data.kolam_renang.data
    kolamRenang.value.kolamRenang = {
      // eslint-disable-next-line camelcase
      bilangan_premis_kolam_renang: kolamRenang.value ? kolamRenang.value.bilangan_premis_kolam_renang : 0,
    }

  } catch (err) {
    console.error('loadDataFromApi failed:', err)
  } 
}

onMounted(() => {
  loadDataFromApi()
})
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%);
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
  box-sizing: border-box;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%; 
  height: auto;
}

.line-under-image {
  width: 70%; 
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 10px;
  text-align: left;
  width: 100%;
}

.kolam-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  gap: 20px; 
}

.kolam-image-container {
  display: flex;
  justify-content: center; 
  width: 100%;
  margin-bottom: 40px;
  border-radius: 20px;
}

.kolam-image-container img {
  width: auto;
  max-width: 100%;
  height: auto;
  border-radius: 10px;
}

.kolam-text-box {
  position: relative;
  margin-top: 40px;
  margin-bottom: 40px;
}

.text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #150069;
  z-index: 1;
  width: 100%;
}

.value {
  font-size: 96px;
  font-weight: 600;
  color: #150069;
}

.kolam {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  flex-wrap: nowrap;
}

.kolam-container {
  width: 48%;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
}

.video-container {
  position: relative;
  width: 100%;
  max-width: 100%;
  border-radius: 10px;
}

.video-container video {
  width: 100%;
  height: auto;
}

.overlay-number {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 76px;
  font-weight: 600;
  color: #150069;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 10px 20px;
  border-radius: 10px;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 10px;
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; 
}

.values-layered h3 {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.num {
  font-size: 34px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

.overlay-text {
  position: absolute;
  top: 80%; 
  left: 50%; 
  transform: translate(-50%, -50%);
  color: #150069;
  font-size: 54px;
  font-weight: 600;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 10px 20px;
  border-radius: 10px;
  text-align: center;
}

.overlay-text h3 {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: black;
}

.number {
  font-size: 54px;
  font-weight: 600;
  color: #150069;
  margin-top: 10;
}

.kolam {
  display: grid;
  grid-template-columns: repeat(2, 1fr); 
  grid-gap: 20px;
}

.kolam-container {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  width: 100%; 
  height: auto;
}



@media (max-width: 768px) {
  .pbt-image, .line-under-image {
    width: 90%;
  }

  .overlay-number {
    font-size: 2.5rem;
  }

  .kolam {
    grid-template-columns: 1fr;
  }

  .values-layered h3 {
    font-size: 1.2rem;
  }

  .num {
    font-size: 1.8rem;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 15px;
  }

  h2 {
    font-size: 1.2rem;
  }

  .overlay-number {
    font-size: 2rem;
  }

  .values-layered h3 {
    font-size: 1rem;
  }

  .num {
    font-size: 1.5rem;
  }
}
</style>
